import "./widgetInfoContainer.less"

import React from "react";

import {translator} from "core/localization/localization";
import {Window} from 'controls/react/kendoWrappers/window';
import {FormLayout} from 'controls/react/layout/formLayout';
import {Section} from 'controls/react/layout/section';

import SqInfoForm from "../../areas/services/designer/qualifierWizard/subforms/sqInfoForm";
import FieldRow from 'controls/react/fieldRow';
import Lang from 'core/localization/lang'

let i = translator({
  "Metric information": {
    "no": "Metrikk informasjon",
    "en": "Metric information"
  },
  "Chart settings": {
    "no": "Graf innstillinger",
    "en": "Chart settings"
  }
});

function translateLabels(field) {
	switch (field) {
		case 'accountId':
			return lang.account.ACCOUNT_ID;
		case 'accountName':
			return lang.account.ACCOUNT_NAME;
		case 'agentId':
			return lang.serviceBoard.AGENT_ID;
		case 'agentName':
			return lang.serviceBoard.AGENT_NAME;
		case 'algorithm':
			return lang.designer.ALGORITHM;
		case 'assetId':
			return lang.serviceBoard.ASSET_NAME;
		case 'assetName':
			return lang.serviceBoard.ASSET_NAME;
		case 'breachValue':
			return lang.widget.BREACH_VALUE;
		case 'categoryId':
			return lang.serviceBoard.CATEGORY_ID;
		case 'categoryNode':
			return lang.serviceBoard.CATEGORY_NODE;
		case 'categoryPath':
			return lang.serviceBoard.CATEGORY_PATH;
		case 'categoryText':
			return lang.CATEGORY;
		case 'dataType':
			return lang.serviceBoard.METRIC_TYPE;
		case 'description':
			return lang.DESCRIPTION;
		case 'instanceName':
			return lang.serviceBoard.INSTANCE_NAME;
		case 'inverted':
			return lang.widget.INVERT;
		case 'maxValue':
			return lang.widget.MAX_VALUE;
		case 'minValue':
			return lang.widget.MIN_VALUE;
		case 'metricId':
			return lang.serviceBoard.METRIC_ID;
		case 'metricType':
			return lang.serviceBoard.METRIC_TYPE;
		case 'monitorName':
			return lang.assethealth.MONITOR_NAME;
		case 'monitorTypeName':
			return lang.assethealth.MONITOR_TYPE;
		case 'operator':
			return lang.designer.OPERATOR;
		case 'persist':
			return lang.PERSIST;
		case 'profileText':
			return lang.PROFILE;
		case 'registryIdentifier':
			return lang.serviceBoard.REGISTRY_IDENTIFIER;
		case 'registryOwnerId':
			return lang.serviceBoard.REGISTRY_OWNER_ID;
		case 'registryOwnerName':
			return lang.serviceBoard.SOURCENAME;
		case 'registryType':
			return lang.serviceBoard.REGISTRY_TYPE;
		case 'ruleTypeText':
			return lang.kpi.RULE_TYPE;
		case 'sampleRateText':
			return lang.kpi.SAMPLE_RATE;
		case 'threshold':
			return lang.designer.THRESHOLD;
		case 'unitType':
			return lang.serviceBoard.UNIT_TYPE;
		case 'unitTypeSymbol':
			return lang.serviceBoard.UNIT_TYPE_SYMBOL;
		default:
			return field;
	}
}


export const WidgetInfo = (props) => {
	let chartSettings = props.chartSettings;
	let infoWindowWidth = props.isAnyFlag ? 650 : 450;

	return <Section appearance={"none"}
	                contentPadding={true}
	                contentClass={"widget-info-container"}
	                direction={"row"}
	                width={infoWindowWidth}
	                childrenPadding={true}>
		<Section appearance={'frame'} title={i('Metric information')}>
			{props.type === 'request' && <SqInfoForm {...props.data}/>}
			<div>
				{props.type === 'preloaded' && Object.keys(props.data ?? {}).map(field =>
					props.data[field] != null && <FieldRow key={field} label={translateLabels(field)} content={props.data[field]}/>)}
			</div>
		</Section>
		{props.isAnyFlag && <Section appearance={'frame'} title={i('Chart settings')}>
			<div>
				{props.flags.hasAggregation && <FieldRow label={lang.widget.AGGREGATION}
				                                              content={chartSettings.aggregationType || 'high'}/>}
				{props.flags.hasChartType && <FieldRow label={lang.widget.CHART_TYPE}
				                                            content={chartSettings.chartType || 'line'}/>}
				{props.flags.hasMissingData && <FieldRow label={lang.widget.messages.MISSING_DATA}
				                                              content={JSON.stringify(chartSettings.ignoreMissingData || false)}/>}
				{props.flags.hasRegression && <FieldRow label={lang.widget.messages.TREND}
				                                             content={JSON.stringify(chartSettings.showRegression || false)}/>}
				{props.flags.hasThreshold && <FieldRow label={lang.widget.messages.THRESHOLD}
				                                            content={JSON.stringify(chartSettings.showThreshold || false)}/>}
			</div>
		</Section>}
	</Section>
}

export default class WidgetInfoContainer extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		let screenWidth = window.innerWidth;
		let coordinates = this.props.coordinates;
		let infoWindowHeight = 295;
		let infoWindowWidth = this.props.isAnyFlag ? 650 : 450;
		let infoWindowLeft;
		if (coordinates.left + infoWindowWidth < screenWidth) {
			infoWindowLeft = coordinates.left + 30;
		} else {
			infoWindowLeft = coordinates.left - infoWindowWidth - 10;
		}
		let chartSettings = this.props.chartSettings;
		return (
			<Window height={infoWindowHeight}
					width={infoWindowWidth}
					title={false}
					left={infoWindowLeft}
					top={coordinates.top - 30}
					onClose={() => this.onClose()}
					windowRef={this.windowRefSet}>
				<Section appearance={"none"}
				         contentPadding={true}
				         contentClass={"widget-info-container"}
				         direction={"row"}
				         childrenPadding={true}>
					<Section appearance={'frame'} title={i('Metric information')}>
						{this.props.type === 'request' && <SqInfoForm {...this.props.data}/>}
						<div>
							{this.props.type === 'preloaded' && Object.keys(this.props.data ?? {}).map(field =>
								this.props.data[field] != null && <FieldRow key={field} label={translateLabels(field)} content={this.props.data[field]}/>)}
						</div>
					</Section>
					{this.props.isAnyFlag && <Section appearance={'frame'} title={i('Chart settings')}>
						<div>
							{this.props.flags.hasAggregation && <FieldRow label={lang.widget.AGGREGATION}
																		  content={chartSettings.aggregationType || 'high'}/>}
							{this.props.flags.hasChartType && <FieldRow label={lang.widget.CHART_TYPE}
																		content={chartSettings.chartType || 'line'}/>}
							{this.props.flags.hasMissingData && <FieldRow label={lang.widget.messages.MISSING_DATA}
																		  content={JSON.stringify(chartSettings.ignoreMissingData || false)}/>}
							{this.props.flags.hasRegression && <FieldRow label={lang.widget.messages.TREND}
																		 content={JSON.stringify(chartSettings.showRegression || false)}/>}
							{this.props.flags.hasThreshold && <FieldRow label={lang.widget.messages.THRESHOLD}
																		content={JSON.stringify(chartSettings.showThreshold || false)}/>}
						</div>
					</Section>}
				</Section>
			</Window>
		)
	}

	windowRefSet = ref => {
		this.window = ref;

		//remove window header padding to save space
		let container = this.window.wrapper;
		let containerStyle = container.attr('style');
		containerStyle += 'padding-top: 0 !important;';
		container.attr('style', containerStyle);

		//adapt window height to dynamic container height to save space
		let kendoWindow = this.window;
		let actualContainerHeight = kendoWindow.wrapper.find('.section').first().height() + 20;
		let coordinates = this.props.coordinates;
		let screenHeight = window.innerHeight;
		let infoWindowTop;
		if (coordinates.top + actualContainerHeight > screenHeight) {
			infoWindowTop = screenHeight - actualContainerHeight - 10;
		} else {
			infoWindowTop = coordinates.top - 30;
		}
		kendoWindow.setOptions({
			height: actualContainerHeight,
			position: {
				top: infoWindowTop,
				left: kendoWindow.options.position.left
			}
		});

		//remove links, no chance to click since it's shown only on hover
		container.find('.cw_link').removeClass('cw_link');
	}

	componentDidUpdate() {

	}

	onClose = () => {

	}
}
